import * as React from "react";
import { NavLink } from "react-router-dom";
import { Layout, Menu } from "antd";
import UserAvatar from "./UserAvatar";
import IfAuthenticated from "../IfAuthenticated";
const { Header } = Layout;

export interface Props {
  children?: React.ReactNode;
  padding?: number | string;
}

export interface State {}

export default class NavTop extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    const padding = this.props.padding || "25%";
    return (
      <Header
        style={{
          paddingLeft: padding,
          paddingRight: padding,
          background: "#ffffff",
          borderBottom: "1px solid #e8e8e8"
        }}
        className="header"
      >
        <div
          style={{
            width: 180,
            height: 31,
            margin: "0 28px 16px 0",
            float: "left"
          }}
        >
          <NavLink to="/">
            <img
              alt="logo"
              src="https://minio.pisku.la/public/JG_colorOnWhite.svg"
            />
          </NavLink>
        </div>
        <div
          style={{
            float: "right"
          }}
        >
          <UserAvatar />
        </div>
        <Menu
          mode="horizontal"
          defaultSelectedKeys={[]}
          style={{ lineHeight: "62px", minHeight: 64 }}
        >
          <Menu.Item key="/users">
            <IfAuthenticated scope="users">
              <NavLink to="/users">Users</NavLink>
            </IfAuthenticated>
          </Menu.Item>
          <Menu.Item key="/roles">
            <IfAuthenticated scope="users">
              <NavLink to="/roles">Roles</NavLink>
            </IfAuthenticated>
          </Menu.Item>
          <Menu.Item key="/orders">
            <IfAuthenticated scope="orders">
              <NavLink to="/orders">Orders</NavLink>
            </IfAuthenticated>
          </Menu.Item>
          <Menu.Item key="/mailinglists">
            <IfAuthenticated scope="mail-list">
              <NavLink to="/mailinglists">Mail List</NavLink>
            </IfAuthenticated>
          </Menu.Item>
        </Menu>
      </Header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavTop/NavTop.tsx